var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{ref:_vm._uid,staticClass:"media-content",attrs:{"cols":"6","md":"6"}},[_c('div',{staticClass:"area-video-info d-flex align-baseline caption grayDark--text"},[_c('b',[_vm._v(_vm._s(_vm.user.name)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }